import { WorkItemContext } from "@platform/core";
import { WorkItem } from "../models/WorkItem";

function createContext(workItem: WorkItem): WorkItemContext {
  if (workItem?.Associations?.[0]?.hasOwnProperty("Key")) {
    return {
      WorkItemId: workItem.WorkItemIdentifier,
      Associations: [
        {
          Type: workItem?.Context ? workItem.Context.toLowerCase() : "loan",
          Key: workItem.Associations[0].Key,
        },
      ],
    } as unknown as WorkItemContext;
  }
  return undefined as unknown as WorkItemContext;
}
export default createContext;
